import i18n from "@/i18n/index";
export default class DataRoaming {
}
DataRoaming.Breadcrumbs = [
    {
        to: "/",
        text: i18n.t("breadcrumbs.home"),
    },
    {
        to: "/secure/shop/offers",
        text: i18n.t("breadcrumbs.roaming"),
        disabled: true,
    },
];
DataRoaming.RoamingZoneCreateBreadcrumbs = [
    {
        to: "/",
        text: i18n.t("breadcrumbs.home"),
    },
    {
        to: "/secure/shop/offers",
        exact: true,
        text: i18n.t("breadcrumbs.roaming"),
    },
    {
        to: "/admin/catalog/offers/create",
        text: i18n.t("breadcrumbs.roaming_create"),
        disabled: true,
    },
];
DataRoaming.OfferEditBreadcrumbs = [
    {
        to: "/",
        text: i18n.t("breadcrumbs.home"),
    },
    {
        to: "/secure/shop/offers",
        exact: true,
        text: i18n.t("breadcrumbs.roaming"),
    },
    {
        to: "/admin/catalog/offers/create",
        text: i18n.t("breadcrumbs.roamint_edit"),
        disabled: true,
    },
];
DataRoaming.TableHeaders = [
    {
        text: i18n.t("table_headers.sorting"),
        value: "zone_order",
    },
    {
        text: i18n.t("table_headers.zone_name"),
        value: "zone_name",
    },
    {
        text: i18n.t("table_headers.group_1_call"),
        value: "group_1_call_price",
    },
    {
        text: i18n.t("table_headers.group_2_call"),
        value: "group_2_call_price",
    },
    {
        text: i18n.t("table_headers.group_3_call"),
        value: "group_3_call_price",
    },
    {
        text: i18n.t("table_headers.group_4_call"),
        value: "group_4_call_price",
    },
    {
        text: i18n.t("table_headers.group_5_call"),
        value: "group_5_call_price",
    },
    {
        text: i18n.t("table_headers.group_1_sms"),
        value: "group_1_sms_price",
    },
    {
        text: i18n.t("table_headers.group_2_sms"),
        value: "group_2_sms_price",
    },
    {
        text: i18n.t("table_headers.group_3_sms"),
        value: "group_3_sms_price",
    },
    {
        text: i18n.t("table_headers.group_4_sms"),
        value: "group_4_sms_price",
    },
    {
        text: i18n.t("table_headers.group_5_sms"),
        value: "group_5_sms_price",
    },
    {
        text: i18n.t("table_headers.incoming_call"),
        value: "incoming_call_price",
    },
    {
        text: i18n.t("table_headers.data_mb"),
        value: "data_mb_price",
    },
    {
        text: i18n.t("table_headers.action"),
        value: "action",
    },
];
